import React from "react";

import {
    Heading,
    Container,
    Row,
    Col,
    Text
} from 'aplazame-design-system';

import HeaderSection from '../HeaderSection';
import WordpressPostsSection from '../WordpressPostsSection';

import textStyle from 'aplazame-design-system/src/scss/text.module.scss';


export default function HeaderBlogSubpageSection({
    title,
    titleTag,
    subtitle,
    hasPagination,
    parentSection,
    parentHeaderSection,
    posts
}) {
    return (
        <>
            {parentSection ? (
                <HeaderSection
                    {...parentHeaderSection}
                />
            ) : null}
            <section>
                <Container
                    pt={{ xs: 10, lg: 5 }}
                    pb={{ xs: 5 }}
                >
                    <Row>
                        <Col col={{ lg: 6 }} offset={{ lg: 3 }} className="text-lg-center">
                            <Heading
                                tag={titleTag}
                                className={`h2 mb-3 ${textStyle.gradual}`}
                                data-sal="slide-up"
                                data-sal-easing="ease-out-quart"
                                data-sal-delay="xs-none--lg-1200"
                            >
                                {title}
                            </Heading>
                            {subtitle ? (
                                <Text
                                    tag="div"
                                    className="h4"
                                    data-sal="slide-up"
                                    data-sal-easing="ease-out-quart"
                                    data-sal-delay="xs-none--lg-1200"
                                >
                                    {subtitle}
                                </Text>
                            ) : null}
                        </Col>
                    </Row>
                </Container>
            </section>
            {parentSection ? (
                <WordpressPostsSection
                    {...parentSection}
                    hasPagination={hasPagination}
                    posts={posts}
                />
            ) : null}
        </>
    );
}
